// No imports on purpose: the API server loads this file at runtime
// (routes/v2/opsanio.ts) and cannot resolve the UI's `src/` alias.

/**
 * Rings of the pinned APT suite (opsanio/most `apt:promote:*`). A ring is a
 * moving OCI tag on the signed dists artifact, not a version - promotion is a
 * retag, so every ring carries the same suite name (`opsanio-dev`) inside.
 * Kept in this one list so a rename (opsanio/documentation#321) is one edit.
 */
export const OPSANIO_APT_RINGS = ["dev", "test", "prod"] as const;
export type OpsanioAptRing = (typeof OPSANIO_APT_RINGS)[number];

/** `""` means "not pinned": the appliance renders no `aptDists` block. */
export const isOpsanioAptRing = (value: unknown): value is OpsanioAptRing | "" =>
  value === "" || (OPSANIO_APT_RINGS as readonly unknown[]).includes(value);
